import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExitToApp from '@material-ui/icons/ExitToApp'
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import StoreIcon from '@material-ui/icons/Store';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PersonPinIcon from '@material-ui/icons/PersonPinCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Avatar from '@material-ui/core/Avatar';

import Checkbox from '@material-ui/core/Checkbox';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MotorcycleIcon from '@material-ui/icons/Motorcycle';
import PaymentIcon from '@material-ui/icons/Payment';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import FaceIcon from '@material-ui/icons/Face';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import CircularProgress from '@material-ui/core/CircularProgress';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import SwapHorizIcon from '@material-ui/icons/SwapHoriz';
import Mainmenu from '../../components/mainmenu';

import _ from "lodash";
import firebase from '../../Firebase';
import AsyncStorage from '@callstack/async-storage';
import moment from 'moment';

const drawerWidth = 240;

const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500],
  },
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2,
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit,
  },
}))(MuiDialogActions);

const styles = theme => ({
  '@global': {
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: '#f2a811',
      borderRadius: '5px',
    }
  },
  hide: {
    display:'none',
  },
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
    backgroundColor: '#f2a811',
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  toolbarAvatar: {
    borderRadius: 0,
    width: 170,
    left: 10,
  },
  toolbarIconButton:{
    right:0,
    position:'absolute'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  loadingColorPrimary: {
    backgroundColor: '#f2a811',
  },
  loadingBarColorPrimary: {
    backgroundColor: '#b1730d',
  },
  userAvatar:{
    backgroundColor: '#b1730d',
  },
  button: {
    color: '#fff',
    backgroundColor: '#f2a811',
    '&:hover': {
      backgroundColor: '#b1730d',
    },
  },
  input: {
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  checkbox: {
    color: '#f2a811',
    '&$checked': {
      color: '#f2a811',
    },
  },
  table: {
    display: 'block',
    width: '100%',
    overflowX: 'auto',
  },
  buttonProgress: {
    color: "#fff",
  },
  select: {
    width: '100%',
    '&:after': {
      borderBottomColor: '#f2a811',
    },
  },
  avatar:{
    backgroundColor: '#b1730d',
  },
  div_100p:{
    width: "100%",
    marginTop: 15,
    marginBottom: 15,
  },
});

class ProductRequests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      deleting: false,
      user: {},
      drawer: true,
      config:{},
      searchedTxt: "",
      searchedArr: [],
      dialog: false,
      dialogType: "",
      productRequests: [],
      productRequest_id: "",
    }
  }

  componentWillMount(){
    AsyncStorage.getItem("user").then(u => {
      if (u) {
        const t = this;
        let user = JSON.parse(u);
        let productRequests = [];
        firebase.firestore().collection("config").get().then(snapshot => {
          t.setState({config:JSON.parse(snapshot.docs[0]._document.data.toString()), user:user});
        });
        firebase.firestore().collection('productRequest').onSnapshot(function(docs) {
          productRequests = []
          docs.forEach(doc => {
            let productRequest = JSON.parse(doc._document.data.toString());
            productRequest.id = doc.id;
            productRequests.push(productRequest);
          });
          t.setState({productRequests:productRequests, user:user, loading:false});
        });
      } else
        this.props.navigation.navigate('Login');
    });
  }

  async logout(){
    try {
      //await AsyncStorage.removeItem('user');
      this.props.navigation.navigate('Login');
    } catch (error) {
      console.log(error);
    }
  }

  onSearch(s){
    let searchedArr = [];
    let searched = s.toUpperCase();
    let productRequests = this.state.productRequests;
    productRequests.map((p, i) => {
      const name = p.product_name.toUpperCase();
      if(name.includes(searched))
        searchedArr.push(p);
    });
    this.setState({ searchedArr:searchedArr, searchedTxt:s});
  }

  toggleDrawer(){
    this.setState({ drawer:!this.state.drawer });
  }

  toggleDialog(){
    this.setState({ dialog:!this.state.dialog, });
  }

  toggleDelete(obj){
    this.toggleDialog();
    this.setState({dialogType:"delete", productRequest_id:obj.id});
  }

  goTo(p){
    this.props.navigation.navigate(p);
  }

  checkProductRequestsRows(ptr){
    let totalUndefined = 0;
    
    if(_.isEmpty(ptr))
      return false

    ptr.map(p => {
      if(p == undefined)
        totalUndefined++;
    });

    if(ptr.length == totalUndefined)
      return true
    else
      return false
  }

   delete(){
    const t = this;
    t.setState({deleting:true});
    firebase.firestore().collection("productRequest").doc(t.state.productRequest_id).delete().then(function() {
      t.toggleDialog();
    }).catch(function(error) {
      console.error("Error removing document: ", error);
    });
  }

  render() {
    const { classes } = this.props;
    let productRequests = this.state.productRequests;
    let productRequestsTableRows;

    if(!_.isEmpty(productRequests)){
      if(this.state.searchedTxt != "")
        productRequests = this.state.searchedArr;

      productRequestsTableRows = productRequests.map((p, i) => {
        return (
          <TableRow key={i}>
            <TableCell component="th" scope="row">{ p.product_name }</TableCell>
            <TableCell component="th" scope="row">
              <Button
                variant="contained"
                className={classes.button}
                onClick={() => this.toggleDelete(p)}
              >
                <DeleteForeverIcon/>
              </Button>
            </TableCell>
          </TableRow>
        );
      });
    }

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={classNames(classes.appBar, this.state.drawer && classes.appBarShift)}
        >
          <Toolbar disableGutters={!this.state.drawer} className={classes.toolbar}>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={() => this.toggleDrawer()}
              className={classNames(
                classes.menuButton,
                this.state.drawer && classes.menuButtonHidden,
              )}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="inherit"
              noWrap
              className={classes.title}
            >
              Product Requests
            </Typography>
            <IconButton color="inherit" onClick={() => this.logout()}>
              <ExitToApp />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.drawer && classes.drawerPaperClose),
          }}
          open={this.state.drawer}
        >
          <div className={classes.toolbarIcon}>
            <Avatar src="https://firebasestorage.googleapis.com/v0/b/easysuki-dev.appspot.com/o/assets%2FeasySuki-toolbar.png?alt=media&token=3b713ebc-804c-4e5f-8362-aa5d48f5ff29" className={classes.toolbarAvatar}/>
            <IconButton onClick={() => this.toggleDrawer()} className={classes.toolbarIconButton}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <Mainmenu navigation={this.props.navigation} active="productrequest" />
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          {/*<Typography variant="h4" gutterBottom component="h2">
            Orders
          </Typography>
          <Typography component="div" className={classes.chartContainer}>
            <SimpleLineChart />
          </Typography>
          <Typography variant="h4" gutterBottom component="h2">
            Products
          </Typography>*/}
          <div className={classes.tableContainer}>
            { !this.state.loading &&
              [
                <Grid container spacing={24}>
                  <Grid key={0} item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth className={classes.margin}>
                      <Input
                        placeholder="Search"
                        className={classes.input}
                        onChange={event => this.onSearch(event.target.value)}
                        startAdornment={<InputAdornment position="start"><SearchIcon/></InputAdornment>}
                      />
                    </FormControl>
                  </Grid>
                </Grid>,
                <br key={1} />,
              ]
            }
            { this.state.loading ?
                <Paper className={classes.root}>
                  <Table className={classes.table}>
                    <LinearProgress
                      classes={{
                        colorPrimary: classes.loadingColorPrimary,
                        barColorPrimary: classes.loadingBarColorPrimary,
                      }}
                    />
                  </Table>
                </Paper>
              :
                <Paper className={classes.root}>
                  { this.checkProductRequestsRows(productRequestsTableRows) ?
                      <div className={classes.div_100p}>
                        <center>No product requests</center>
                      </div>
                    :
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Product Name</TableCell>
                            <TableCell>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {productRequestsTableRows}
                        </TableBody>
                      </Table>
                  }
                </Paper>
            }
          </div>
        </main>
        <Dialog
          onClose={() => {this.setState({dialog:false})}}
          aria-labelledby="customized-dialog-title"
          open={this.state.dialog}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
            { this.state.dialogType == "delete" && "Confirm Delete" }
          </DialogTitle>
          <DialogContent>
            { this.state.dialogType == "delete" && "Are you sure you want to delete this item in the inventory?" }
          </DialogContent>
          <DialogActions>
            { this.state.dialogType == "delete" &&
              <Button className={classes.button} onClick={() => this.delete()} color="primary">
                { this.state.deleting ?
                    <CircularProgress size={24} className={classes.buttonProgress} />
                  :
                    "Yes"
                }
              </Button>
            }
            <Button className={classes.button} onClick={() => { if(!this.state.deleting){ this.toggleDialog() } }} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ProductRequests.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductRequests);